import {
  StatsCard,
  StatsCardLoading,
} from "V2.0/HomePages/Dashboard/components/Stats";

export default function CallConcurrency(props) {
  const { isLoading, concurrentCalls, concurrencyLimit } = props;

  if (isLoading) {
    return <StatsCardLoading showBorder={true}/>;
  }

  return (
    <StatsCard
      showBorder={true}
      title="Concurrency"
      total={concurrencyLimit}
      used={concurrentCalls}
      calculateAvailable={(total, used) => total - used}
      calculateWidth={(total, used) => Math.floor((used / total) * 100)}
      unit="calls"
    />
  );
}
